var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNovusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 458.55 175.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002e5d;}.cls-2{fill:#28a228;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.88,50l75.67,60.88,3-3.69-5-4a13.62,13.62,0,0,1-1.74-1.74,16.53,16.53,0,0,1-1.24-1.65,16.15,16.15,0,0,1-1.84-3.84,18.51,18.51,0,0,1-.87-4.48c0-.48-.05-1-.05-1.45,0-8.73,5.39-15,13-16.54l-2.45-4.23C133,71.6,126.73,79.53,126.73,89.94a23.57,23.57,0,0,0,.51,4.89L66.86,46.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.69,71l4.52,3.65A38,38,0,0,1,132,51.48l-2.46-4.26A43,43,0,0,0,105.69,71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,79.4,120.37,83a27.45,27.45,0,0,1,17.94-20.8l-2.34-4A31.89,31.89,0,0,0,116,79.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.41,125.79,51.74,64.91l-3,3.69,5,4.05a13.46,13.46,0,0,1,1.73,1.73,15.74,15.74,0,0,1,3.09,5.49,18.51,18.51,0,0,1,.87,4.48c0,.48.05,1,.05,1.45,0,8.73-5.39,15-13,16.54L49,106.57c9.25-2.43,15.54-10.36,15.54-20.77a23.57,23.57,0,0,0-.51-4.89l60.38,48.58Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.6,104.7l-4.52-3.65a38,38,0,0,1-21.81,23.21l2.46,4.26A43,43,0,0,0,85.6,104.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.31,96.34l-4.39-3.55A27.43,27.43,0,0,1,53,113.59l2.34,4A31.86,31.86,0,0,0,75.31,96.34Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.33,
    y: 39.3,
    width: 4.76,
    height: 97.1,
    transform: "translate(-32.74 107.35) rotate(-51.18)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.23,91.07h-6.41L176.27,59.23l0,31.84h-7.1v-44h6.41l24.57,31.84V47.07h7.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,69.07c0,13.14-9.53,22.82-23,22.82s-23-9.68-23-22.82,9.53-22.82,23-22.82S266,55.93,266,69.07Zm-38.63,0c0,9.49,6.6,16,15.59,16s15.59-6.51,15.59-16-6.6-16-15.59-16S227.37,59.58,227.37,69.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.37,91.07H289.5l-16.78-44h7.58L294,83.87l13.8-36.8h7.35Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.52,73.72c0,12.23-8.27,18.13-18.67,18.13S326.18,86,326.18,73.72V47.07h7.1V73.19C333.28,81.58,338,85,344.85,85s11.56-3.45,11.56-11.84V47.07h7.11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.45,56.81A22.73,22.73,0,0,0,395.1,53c-5.87,0-9.9,2.55-9.9,6.57,0,3.65,3.43,5.06,9.15,5.88l3,.41c7.13,1,14.17,3.92,14.17,12.09,0,9-8.11,13.86-17.63,13.86-6,0-13.14-2-17.69-5.9l3.86-5.66c3,2.76,8.71,4.84,13.8,4.84,5.75,0,10.27-2.45,10.27-6.51,0-3.45-3.45-5.06-9.9-5.94l-3.42-.47c-6.54-.91-13-4-13-12.16,0-8.83,7.82-13.73,17.35-13.73a27.62,27.62,0,0,1,15.9,4.74Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.86,119.39H181V112.3h2.73v16.88H181V122h-9.11v7.21h-2.72V112.3h2.72Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.23,120.74a8.84,8.84,0,1,1-8.84-8.75A8.49,8.49,0,0,1,206.23,120.74Zm-14.82,0a6,6,0,1,0,6-6.14A5.82,5.82,0,0,0,191.41,120.74Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.26,129.18h-2.72V115.29l-4.93,12.23h-2.87l-4.93-12.1v13.76h-2.72V112.3h4.18l4.9,12,4.91-12h4.18Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.34,129.18H235V112.3h12.15v2.56h-9.43v4.54h9.1V122h-9.1v4.66h9.58Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.55,129.18h-2.73V115.29l-4.93,12.23H268l-4.93-12.1v13.76h-2.72V112.3h4.18l4.91,12,4.9-12h4.19Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.07,120.74a8.83,8.83,0,1,1-8.83-8.75A8.48,8.48,0,0,1,301.07,120.74Zm-14.81,0a6,6,0,1,0,6-6.14A5.82,5.82,0,0,0,286.26,120.74Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.88,112.3c3.88,0,6,1.74,6,4.88,0,2.87-2.19,4.78-5.62,4.9l5.55,7.1h-3.37l-5.38-7.1h-1.37v7.1h-2.73V112.3Zm-4.22,2.56v4.74h4.14c2.2,0,3.22-.79,3.22-2.42s-1.08-2.32-3.22-2.32Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.48,114.88H330v14.3H327.3v-14.3h-5.46V112.3h13.64Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.51,114.71l-2,1.94a6.07,6.07,0,1,0-4.65,10.22c3.07,0,4.88-1.59,5.32-4.37H347.7V120h7.43c0,.21,0,.43,0,.65,0,4.84-3.07,8.86-8.29,8.86A8.75,8.75,0,1,1,347,112,8.6,8.6,0,0,1,353.51,114.71Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M374.33,129.18H371.4l-1.66-4.31H362.1l-1.66,4.31H357.6l6.67-16.88h3.4Zm-11.23-6.89h5.64L365.92,115Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.15,114.71l-2,1.94a6.07,6.07,0,1,0-4.65,10.22c3.07,0,4.88-1.59,5.31-4.37h-4.47V120h7.43c0,.21,0,.43,0,.65,0,4.84-3.07,8.86-8.29,8.86a8.75,8.75,0,1,1,.12-17.49A8.6,8.6,0,0,1,392.15,114.71Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411,129.18H398.65V112.3H410.8v2.56h-9.43v4.54h9.1V122h-9.1v4.66H411Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovusLogo);
export default __webpack_public_path__ + "static/media/Novus_logo.e3dbe9625d1e8e332ccca1e5073b5759.svg";
export { ForwardRef as ReactComponent };